import angular from 'angular';
import tabContent from './tabContent';

export default angular.module('insuranceCustomerCare.scenes', [tabContent])
  .name;
